// @flow
import { get, post } from './common';
import { handleAPIErrors } from '../sentry-util';

export const fetchWallet = async (mobile: string, session: string) => {
	try {
		const res = await get(`/customer/wallet/getWallet`, { user_id: mobile }, { session });
		const { data = {}, status = false, msg = 'Error while fetching your wallet.' } = res;
		if (!status) {
			throw new Error(msg);
		}

		return data;
	} catch (error) {
		handleAPIErrors(error, '/customer/wallet/getWallet', 'GET', { user_id: mobile });
		throw error;
	}
};

export const loadWallet = async (
	{
		mobile,
		amount,
		payment_gateway,
		deviceType,
		vpa,
		...rest
	}: {
		mobile: string,
		amount: string,
		payment_gateway: string,
		deviceType: string,
		vpa: string // upi collect flow requirement
	},
	session: string
) => {
	try {
		const res = await post(
			`/customer/wallet/loadMoney`,
			{ mobile, amount, payment_gateway, deviceType, vpa, ...rest },
			{ session }
		);
		const { status = false, msg = 'Error while loading your wallet.' } = res;
		if (!status && !(payment_gateway === 'PayTM_WALLET' || payment_gateway === 'Ola')) {
			throw new Error(
				msg ||
					`Error while loading wallet.
				Please try again or choose another payment method`
			);
		}

		return res;
	} catch (error) {
		handleAPIErrors(error, '/customer/wallet/loadMoney', 'POST', {
			mobile,
			amount,
			payment_gateway,
			deviceType,
			...rest
		});
		throw error;
	}
};

export const capturePayment = async (
	{
		mobile,
		amount,
		paymentGateway,
		orderId,
		status,
		paymentMethod,
		imei = '',
	}: {
		mobile: string,
		amount: string,
		paymentGateway: string,
		orderId: string,
		status: string,
		paymentMethod?: any,
		imei: string,
	},
	session: string
) => {
	try {
		let apiUrl = '/customer/app';
		let reqBody = {
			mobile,
			amount,
			status,
			orderId,
			payment_gateway: paymentGateway,
			deviceType: process.env.REACT_APP_DEVICE_TYPE || '',
		};
		if (paymentGateway === 'Ola') {
			apiUrl += '/capturePaymentOla';
			reqBody = { ...reqBody, ...paymentMethod, param: 'w' };
		} else {
			apiUrl += '/captureWalletPayment';
			reqBody = { ...reqBody, data: paymentMethod };
		}

		const res = await post(apiUrl, reqBody, { session });
		const { status: resStatus = false, msg = 'Error while loading your wallet.' } = res;
		if (!resStatus) {
			throw new Error(msg);
		}
		return res;
	} catch (error) {
		handleAPIErrors(error, '/customer/app/captureWalletPayment', 'POST', {
			mobile,
			amount,
			paymentGateway,
			orderId,
			status,
			paymentMethod
		});
		throw error;
	}
};

export const fetchWalletRefundList = async (mobile: string, session: string) => {
	try {
		const res = await post('/customer/wallet/getPossibleRefundOptions', { user_id: mobile }, { session });
		const { status = false, msg = 'Error while fetching data' } = res;
		if (!status) {
			throw new Error(msg);
		}
		return res;
	} catch (error) {
		handleAPIErrors(error, '/customer/wallet/getPossibleRefundOptions', 'POST', { user_id: mobile });
		throw error;
	}
};

export const processWalletRefund = async (reqBody: {}, session: string) => {
	try {
		const res = await post('/customer/wallet/refundToSource', reqBody, { session });
		const { status = false, msg = 'Error while processing refund' } = res;
		if (!status) {
			throw new Error(msg);
		}
		return res;
	} catch (error) {
		handleAPIErrors(error, '/customer/wallet/refundToSource', 'POST', { ...reqBody });
		throw error;
	}
};
